import {Box, InputBase, styled, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ReactComponent as AddIcon} from '../../../../../assets/icons/add.svg';
import {ReactComponent as SubtractIcon} from '../../../../../assets/icons/subtract.svg';
import IconButton from '../../../../common/IconButton';

const InputBaseStyled = styled(InputBase)(() => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input': {
    textAlign: 'center',
  },
}));

type SteamInjectionNumberRowProps = {
  steamInjectionNumber: number;
  onChange: (steamInjectionNumber: number) => void;
};

function SteamInjectionNumberRow(props: SteamInjectionNumberRowProps) {
  const {steamInjectionNumber, onChange} = props;
  const {t} = useTranslation();

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', gap: '16px'}}>
      <Box>
        <Typography
          sx={{fontSize: '20px', fontStyle: 'normal', fontWeight: 500, lineHeight: '28px'}}>
          {t('recipe_settings_phases_steam_injection_label')}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            color: 'custom.textTertiary',
          }}>
          {t('recipe_settings_phases_steam_injection_message')}
        </Typography>
      </Box>
      <InputBaseStyled
        sx={{
          width: '96px',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          '& .Mui-disabled': {
            color: 'custom.textPrimary',
            WebkitTextFillColor: (theme) => theme.palette.custom.textPrimary,
          },
        }}
        value={steamInjectionNumber}
        disabled
        startAdornment={
          steamInjectionNumber === 0 ? (
            <Box sx={{minWidth: '32px'}} />
          ) : (
            <IconButton
              IconComponent={SubtractIcon}
              onClick={() => onChange(steamInjectionNumber - 1)}
            />
          )
        }
        endAdornment={
          steamInjectionNumber === 5 ? (
            <Box sx={{minWidth: '32px'}} />
          ) : (
            <IconButton
              IconComponent={AddIcon}
              onClick={() => onChange(steamInjectionNumber + 1)}
            />
          )
        }
      />
    </Box>
  );
}

export default SteamInjectionNumberRow;
